import { apiClient } from "@/lib/api-client";
import type { Review, ReviewResponse, SubmitReviewDto } from "@/lib/types";

export const reviewsApi = {
  /**
   * Submit a review for an order
   * POST /api/orders/:id/review
   */
  submitOrderReview: async (orderId: string, data: SubmitReviewDto): Promise<ReviewResponse> => {
    const response = await apiClient.post(`/orders/${orderId}/review`, data);
    return response.json();
  },

  /**
   * Get customer's review for an order
   * GET /api/orders/:id/review
   */
  getOrderReview: async (orderId: string): Promise<Review | null> => {
    const response = await apiClient.get(`/orders/${orderId}/review`);
    if (response.status === 404) {
      return null; // No review found
    }
    return response.json();
  },

  /**
   * Update an existing review
   * PATCH /api/orders/:id/review
   */
  updateOrderReview: async (orderId: string, data: { rating?: number; comment?: string }): Promise<ReviewResponse> => {
    const response = await apiClient.patch(`/orders/${orderId}/review`, data);
    return response.json();
  },
};
